import Msg from './msg/msg.js'
import Contacts from'./contacts/contacts.js'
import Gallery from './gallery/gallery.js';
import Introduction from './introduction/introduction.js';
import './home.css'
import { useState } from 'react';

// var scrolldown = true;
// const SCROLLRATE = 5;
// const interceptingObj = [];
// const progress = {};
const ENG_TEXTDATA = {
  "company_name":"NEW PHASE RENO",
  "language_title":"ENGLISH",
  "intro_header":"MAKE YOUR DREAM HOME",
  "intro_line1":"Residential kitchen, bathrooms, basment",
  "intro_line2":"High-quality work and attention to detail",
  "intro_line3":"Stress-free, on-time project completion",
  "intro_line4":"15 Years in buisness",
  "transition_title1":"OUR WORK",
  "transition_title2":"CONTACT US",
  "contact1":"PHONE",
  "contact_phone":"416-456-8511",
  "contact2":"EMAIL",
  "contact_email":"newphasereno@gmail.com",
  "msg_header":"LEAVE AN MESSAGE",
  "msg_placeholder1":"NAME",
  "msg_placeholder2":"EMAIL",
  "msg_placeholder3":"INQUIRY",
  "msg_button":"SEND",
  "notification_msg1":"ENTER VALID EMAIL!",
  "notification_msg2":"INQUIRY SENT!",
  "error_msg1":"SERVER ERROR TRY LATER",
  "error_msg2":"CONNECTION ERROR TRY LATER"
}
const CN_TEXTDATA = {
  "company_name":"NEW PHASE RENO",
  "language_title":"中文",
  "intro_header":"为您打造梦想中的家！",
  "intro_line1":"全屋翻新，地下室装修，厕所翻新，橱柜定制。",
  "intro_line2":"高效率，高质量，按时完工。",
  "intro_line3":"覆盖全GTA范围,免费上门咨询",
  "intro_line4":"15从业经验。",
  "transition_title1":"工程项目",
  "transition_title2":"联系我们",
  "contact1":"电话",
  "contact_phone":"647-408-9666",
  "contact2":"邮箱",
  "contact_email":"newphasereno@gmail.com",
  "msg_header":"留言",
  "msg_placeholder1":"姓名",
  "msg_placeholder2":"邮箱",
  "msg_placeholder3":"留言",
  "msg_button":"发送",
  "notification_msg1":"请输入有效邮箱地址!",
  "notification_msg2":"留言成功发送",
  "error_msg1":"服务器故障，请稍后重试",
  "error_msg2":"无法链接服务器，请稍后重试"
}
const DEFAULT_LANGUAGE = ENG_TEXTDATA;

function Home() {
  const [textData,setTextData] = useState(DEFAULT_LANGUAGE);
  const [menu_Droped,setMenuDropped] = useState(false);
  function drop_lan_selection(){
    const dropdiv = document.getElementById("lanList");
    dropdiv.style.display = "block";
    dropdiv.className = "popUps";
    setMenuDropped(true);
  }
  function close_popUps(){
    const lanList = document.getElementById("lanList");
    if(menu_Droped){
      lanList.style.display = "none";
      lanList.className = "";
      setMenuDropped(false);
    }
  }
  function go_to_page(url){
    window.location = url;
  }
  // useEffect(()=>{
  //   //add intersecting div to the interceptingObj array
  //   const observer = new IntersectionObserver(entries => {
  //     entries.forEach(entry => {
  //       if (entry.isIntersecting) {
  //         if(interceptingObj.indexOf(entry.target) === -1){
  //           interceptingObj.push(entry.target);
  //         }
  //       }
  //       else if(!entry.isIntersecting){
  //         if(interceptingObj.indexOf(entry.target) !== -1){
  //           interceptingObj.splice(interceptingObj.indexOf(entry.target),1);
  //         }
  //       }
  //     });
  //   });
  //   observer.observe(document.querySelector('.segmentWrapper1'));
  //   observer.observe(document.querySelector('.segmentWrapper2'));
  //   //add height to target div base on scroll
  //   //progress dictionary is used to track the height of each target div
  //   window.onscroll = function(e) {
  //     // print "false" if direction is down and "true" if up
  //     scrolldown = (this.oldScroll <= this.scrollY);
  //     this.oldScroll = this.scrollY;
  //     interceptingObj.forEach(obj=>{
  //       if(scrolldown === true){
  //         if(progress[obj.className] === undefined){
  //           progress[obj.className] = 0;
  //           obj.style.height = '0px';
  //         }
  //         if(progress[obj.className] >= 400){
  //           obj.style.height = '400px';
  //           progress[obj.className] = 400;
  //           return;
  //         }
  //         obj.style.height = String(progress[obj.className] + SCROLLRATE+'px');
  //         progress[obj.className] = SCROLLRATE + progress[obj.className];
  //       }
  //       else{
  //         if(progress[obj.className] === undefined)progress[obj.className] = 0;
  //         if(progress[obj.className] <= 0){
  //           obj.style.height = '0px';
  //           progress[obj.className] = 0;
  //           return;
  //         }
  //         if(this.scrollY === 0){
  //           obj.style.height = '0px';
  //           progress[obj.className] = 0;
  //           return;
  //         }
  //         obj.style.height = String(progress[obj.className] - SCROLLRATE+'px');
  //         progress[obj.className] = progress[obj.className] - SCROLLRATE;
  //       }
  //     });  
  //   }

  // },[]);
  return (
    <div id="renoSite" onClick={close_popUps}>
      <div id = "background">
        <img src = {process.env.PUBLIC_URL+"/background/buckets-paint-floor.jpg"} alt = "background" width={"100%"} height={"100%"}/>
      </div>
      <div id = "header">
        <div id = "language">
            <div id= 'languageBtn' onClick={drop_lan_selection}>{"🌐"+textData["language_title"]}</div>
            <div id = 'lanList'>
              <div id =  "select_eng" className='select_lan' onClick={()=>{setTextData(ENG_TEXTDATA)}}>{ENG_TEXTDATA["language_title"]}</div>
              <div id =  "select_cn" className='select_lan' onClick={()=>{setTextData(CN_TEXTDATA)}}>{CN_TEXTDATA["language_title"]}</div>
            </div>
        </div>

        <div id = "companyName">{textData["company_name"]}</div>
        
      </div>
      <Introduction textData = {textData}/>
      <div
          className={'segmentWrapper1 segment'}>
            <p className = "segmentLabel">|</p>
            <p className = "segmentLabel">|</p>
            <p className = "segmentLabel">{textData["transition_title1"]}</p>
            <p className = "segmentLabel">|</p>
            <p className = "segmentLabel">|</p>
      </div>
      <Gallery/>
      <div
        className={'segmentWrapper2 segment'}>
          <p className = "segmentLabel">|</p>
          <p className = "segmentLabel">|</p>
          <p className = "segmentLabel">{textData["transition_title2"]}</p>
          <p className = "segmentLabel">|</p>
          <p className = "segmentLabel">|</p>
      </div>
      <div id = "contactbox">
        <Contacts textData = {textData}/>
        <Msg textData = {textData}/>
      </div>
      <div id= "footer">
        <div id="social_links">
          <img 
            id = "fb_logo" alt = "facebook page"src={process.env.PUBLIC_URL+"/Facebook_Logo.png"}
            onClick={()=>{go_to_page("https://www.facebook.com/New-Phase-Renovation-61577226849302/")}}
          />
        </div>

        
      </div>

    </div>
  );
}

export default Home;